import { en, type Messages } from "./messages";

export const ALL_LOCALES = ["en", "de", "fr"] as const;
export type Locale = (typeof ALL_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "en";
export const LOCALE_COOKIE = "fc_lang";

/** Switch a language on by adding its messages here. */
export const ACTIVE_MESSAGES: Partial<Record<Locale, Messages>> = {
  en,
};

export const LOCALE_LABELS: Record<Locale, string> = {
  en: "English",
  de: "Deutsch",
  fr: "Français",
};

export const activeLocales = () => Object.keys(ACTIVE_MESSAGES) as Locale[];

export const isActiveLocale = (value: unknown): value is Locale =>
  typeof value === "string" && value in ACTIVE_MESSAGES;

/** ISO 3166 country code -> locale. */
const COUNTRY_LOCALE: Record<string, Locale> = {
  DE: "de", AT: "de", CH: "de", LI: "de",
  FR: "fr", BE: "fr", LU: "fr", MC: "fr",
};

export function resolveLocale(cookie: string | undefined, country: string | undefined): Locale {
  if (activeLocales().length <= 1) return DEFAULT_LOCALE;
  if (isActiveLocale(cookie)) return cookie;
  const byCountry = country ? COUNTRY_LOCALE[country.toUpperCase()] : undefined;
  return isActiveLocale(byCountry) ? byCountry : DEFAULT_LOCALE;
}

export const messagesFor = (locale: Locale): Messages => ACTIVE_MESSAGES[locale] ?? en;
